import { Box, Typography } from "@mui/material";
import PremiumBadgeIcon from "../../img/icons/vip.png";
import { COLLECTION_TAB } from "../../pages/MyProfile/MyProfile";
import { COLLECTION_SECTION } from "../../pages/MyProfile/Collection/Collection";
import DialogService from "../Dialog/dialogService";
import LinkWrapper from "../LinkWrapper/LinkWrapper";
import ProfileImg from "../ProfileImg/ProfileImg";
import { ShirtOwnerInfoInterface } from "../../services/shirts/types";
import { COUNTRIES } from "../../constants/countries";

interface UserShirtHeaderProps {
  user: ShirtOwnerInfoInterface;
}

const UserShirtHeader = ({ user }: UserShirtHeaderProps) => {
  const { close } = DialogService();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        columnGap: 1,
        width: "100%",
        justifyContent: "flex-start",
      }}
    >
      <Box>
        <ProfileImg
          imgUrl={user.avatar ?? undefined}
          size={30}
          hideShadow={true}
        />
      </Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <LinkWrapper
          visitorUrl="/sign-up"
          freeUserUrl={
            "/my-profile/" +
            user.id +
            "/" +
            COLLECTION_TAB.COLLECTION +
            "/" +
            COLLECTION_SECTION.OVERVIEW
          }
          premiumUserUrl={
            "/my-profile/" +
            user.id +
            "/" +
            COLLECTION_TAB.COLLECTION +
            "/" +
            COLLECTION_SECTION.OVERVIEW
          }
          closeOnVisitor={true}
          closeOnSigned={false}
          component={
            <Typography
              variant="body1"
              sx={{
                color: "#3c3c40",
                fontWeight: "700",
                fontSize: "14px !important",
                ":hover": {
                  color: "#4663ff",
                },
              }}
            >
              {user.username}
            </Typography>
          }
          clickFunction={close}
        />
      </Box>

      <Box display="flex" alignItems="center" gap="1">
        {user.is_vip && (
          <Box sx={{ width: "25px" }}>
            <ProfileImg imgUrl={PremiumBadgeIcon} size={20} hideShadow />
          </Box>
        )}

        {user.country && (
          <Box sx={{ width: "20px" }}>
            <Flag countryLabel={user.country} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

interface FlagProps {
  countryLabel: string | undefined;
}

export const Flag = ({ countryLabel }: FlagProps) => {
  const getCodeFromLabel = (
    countryLabel: string | undefined
  ): string | undefined => {
    if (countryLabel === undefined) {
      return undefined;
    }
    const normalizedLabel = countryLabel.toLowerCase(); // Convertimos a minúsculas para comparar sin importar mayúsculas

    const foundCountry = COUNTRIES.find(
      (country) => country.label.toLowerCase() === normalizedLabel
    );

    return foundCountry ? foundCountry.code : undefined;
  };

  let flag = <></>;
  const code = getCodeFromLabel(countryLabel);
  if (code) {
    flag = (
      <ProfileImg
        imgUrl={`https://flagcdn.com/w40/${code.toLowerCase()}.png`}
        size={16}
        hideShadow
      />
    );
  }
  return flag;
};

export default UserShirtHeader;
